const validFacetedNavigationFacetMatchers = [
  /^attribute_\d+$/,
  /^attr_\d+$/,
  /^range$/,
  /^base_colour$/,
  /^brand$/
];

const getFacetedNavigationParams = ({ refine }) => {
  const refinements = refine
    .split("|")
    .map(refinement => refinement.split(":"));

  const onlyValidFacets = refinements.every(([facet]) =>
    validFacetedNavigationFacetMatchers.some(matcher => matcher.test(facet))
  );

  if (!onlyValidFacets) {
    return {};
  }

  return Object.fromEntries(refinements);
};

export default getFacetedNavigationParams;
